const DEFAULT_DATE_FORMAT = window.Edocat.Config?.dateFormat;
const DEFAULT_TIME_FORMAT = window.Edocat.Config?.timeFormat;

import { is } from 'ramda';

export const getBooleanValue = (value: string | boolean) => {
  if (!value) return false;
  if (is(Boolean, value)) return value;

  return value === 'true';
};

export const getTimeFormat = (showTime: string | boolean, timeFormat?: string) => {
  if (!getBooleanValue(showTime)) {
    return null;
  }

  if (!timeFormat) {
    return DEFAULT_TIME_FORMAT;
  }

  return timeFormat;
};

export const getDateFormat = (showTime: string | boolean, dateFormat?: string, timeFormat?: string) => {
  if (!dateFormat) {
    if (getBooleanValue(showTime)) {
      return `${DEFAULT_DATE_FORMAT} ${getTimeFormat(showTime, timeFormat)}`;
    }

    return DEFAULT_DATE_FORMAT;
  } else if (getBooleanValue(showTime)) {
    return `${dateFormat} ${getTimeFormat(showTime, timeFormat)}`;
  } else {
    return dateFormat;
  }
};
